import { useMsal, useAccount } from '@azure/msal-react';

type IdTokenClaims = {
  email: string | undefined;
  family_name: string | undefined;
  given_name: string | undefined;
  name: string | undefined;
  preferred_username: string | undefined;
  roles: Array<string>;
};

export type AccountInfo = {
  idTokenClaims: IdTokenClaims;
  name: string | undefined;
  username: string | undefined;
  homeAccountId: string | undefined;
};

const useCurrentUser = (): [AccountInfo, boolean] => {
  const { accounts, inProgress, instance } = useMsal();
  const account = instance.getActiveAccount() ?? accounts[0];
  const currentUser = useAccount(account || {});
  const isInProgress = inProgress !== 'none';

  const claims: IdTokenClaims = {
    email: currentUser?.idTokenClaims?.['email'] as string | undefined,
    family_name: currentUser?.idTokenClaims?.['family_name'] as string | undefined,
    given_name: currentUser?.idTokenClaims?.['given_name'] as string | undefined,
    name: currentUser?.idTokenClaims?.['name'] as string | undefined,
    preferred_username: currentUser?.idTokenClaims?.['preferred_username'] as string | undefined,
    roles: (currentUser?.idTokenClaims?.['roles'] as string[]) ?? [],
  };

  const user: AccountInfo = {
    name: currentUser?.name,
    username: currentUser?.username,
    homeAccountId: currentUser?.homeAccountId,
    idTokenClaims: claims,
  };

  return [user, isInProgress];
};

export default useCurrentUser;
